import React from 'react'

import RoleEditBuyerForm from '../../modules/Buyer/components/RoleEditBuyerForm'
export default function RoleEditBuyerPage() {
  return <RoleEditBuyerForm />
}
